<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group>
          <b-form-textarea
            id="transcriptionGpt"
            :value="transcriptionGpt"
            rows="5"
            max-rows="5"
            readonly>
          </b-form-textarea>
        </b-form-group>

        <b-form-group>
          <b-form-textarea
            id="completionGpt"
            :value="completionGpt" 
            rows="5"
            max-rows="5"
            readonly>
          </b-form-textarea>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button @click.prevent="startRecording" :disabled="isRecording" class="audio-recorder"><i class="fa fa-circle"/></b-button>
        <b-button @click.prevent="stopRecording" :disabled="!isRecording" class="audio-recorder"><i class="fa fa-stop"/></b-button>
        <b-button @click.prevent="cancelRecording" :disabled="!isRecording" class="audio-recorder"><i class="fa fa-trash"/></b-button>

        <b-button size="sm" variant="primary" class="footer-button" 
          :disabled="completionGpt === ''"
          @click.prevent="update">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import { audioRecorder } from '../../mixins/audio_recorder'

export default {
  name: 'gptTranscriptionModal',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal,
    audioRecorder
  ],
  data () {
    return {
      labelCols: 2,
      transcriptionGpt: '',
      completionGpt: '',
    }
  },
  created() {
  },  
  methods: {
    onAudioReady(blob) {
      this.showSpinner();
      this.$store.dispatch('ordentrabajo/askTranscription', blob)
        .then(() => {
          this.transcriptionGpt = this.$store.getters['ordentrabajo/transcriptionGpt'];
          this.completionGpt = this.$store.getters['ordentrabajo/completionGpt'];
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    update() {
      let params = {
        updated: true,
        descripcion: this.completionGpt,
      }
      this.$emit('close', params);
    },
    close() {
      let params = {
        updated: false
      }
      this.$emit('close', params);
    },
  },
}
</script>

<style>
  .audio-recorder {
    margin-right: 5px;
  }
  .audio-recorder:nth-child(3) {
    margin-right: 35px;
  }
  .audio-recorder .fa-circle {
    color: #f86c6b;
  }
  .audio-recorder:hover .fa-circle {
    color: #f64846;
  }
  .audio-recorder:disabled .fa-circle {
    color: #f4a7a7;
  }
  .audio-recorder:disabled .fa-stop,
  .audio-recorder:disabled .fa-trash {
    color: #737373;
  }
</style>
